import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// API base URL setup
const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

// localStorage token
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// normal Login
export const loginWithEmail = createAsyncThunk<
  any,
  { email: string; password: string },
  { rejectValue: string }
>('auth/loginWithEmail', async ({ email, password }, { rejectWithValue }) => {
  try {
    const response = await API.post('auth/login', { email, password });
    const data = response.data;
    localStorage.setItem('user', JSON.stringify(data));
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Login failed');
  }
});

// Login with Google
export const loginWithGoogle = createAsyncThunk<
  any,
  { idToken: string },
  { rejectValue: string }
>('auth/loginWithGoogle', async ({ idToken }, { rejectWithValue }) => {
  try {
    const response = await API.post('auth/google', {idToken, type: 'website' });
    const data = response.data;
    localStorage.setItem('user', JSON.stringify(data));
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Google login failed');
  }
});

// Login with Facebook
export const loginWithFB = createAsyncThunk<
  any,
  { fbToken: string },
  { rejectValue: string }
>('auth/loginWithFB', async ({ fbToken }, { rejectWithValue }) => {
  try {
    const response = await API.post('auth/facebook', { token: fbToken });
    const data = response.data;
    localStorage.setItem('user', JSON.stringify(data));
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Facebook login failed');
  }
});

// Signup user
export const signupUser = createAsyncThunk<
  any,
  { name: string; email: string; password: string; confirmPassword: string, role: string, type: string},
  { rejectValue: string }
>('auth/register', async (formData, { rejectWithValue }) => {
  try {
    const response = await API.post('auth/register', formData);
    const data = response.data;
    localStorage.setItem('user', JSON.stringify(data));
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Signup failed');
  }
});

// Get profile
export const getProfile = createAsyncThunk<
  any,
  void,
  { rejectValue: string }
>('auth/getProfile', async (_, { rejectWithValue }) => {
  try {
    const response = await API.get('auth/profile');
    const data = response.data;
    localStorage.setItem('user', JSON.stringify(data));
      if (data.token) {
        localStorage.setItem('token', data.token);
      }
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || 'Failed to fetch profile');
  }
});

// Logout
export const logout = createAsyncThunk('auth/logout', async () => {
  localStorage.removeItem('token');
  return true;
});
